export const formValueInjectKey = Symbol();
export const formErrorsInjectKey = Symbol();
export const setValueInjectKey = Symbol();
export const validateInjectKey = Symbol();
export const setSchemaVisibleInjectKey = Symbol();
